import MetricCard from "./MetricCard";
import RatioPieChart from "./RatioPieChart";

export type RatioMetricCardProps = {
    title: string;
    portion: number;
    total: number;
    href?: string;
};

const RatioMetricCard = ({
    title,
    portion,
    total,
    href,
}: RatioMetricCardProps) => {
    return (
        <MetricCard
            title={title}
            href={href}
            value={
                <div className="flex items-center">
                    <RatioPieChart
                        className="hidden lg:block mr-6"
                        portion={total - portion}
                        total={total}
                    />
                    {
                        <span className="text-[2.813rem]">
                            {`${portion} / ${total}`}
                        </span>
                    }
                </div>
            }
        />
    );
};

export default RatioMetricCard;
